import { Pagination } from "~/types";

export const AUTO_CLOSE = 1000 * 4; // Time for notifications to disappear in milliseconds
export const LARUCHE_IDENTIFIER = "LaR";
export const PAGE_TITLE = "La Ruche Health";
const googleBusinessRating = Number.parseFloat(
  import.meta.env.VITE_GOOGLE_BUSINESS_RATING ?? ""
);

export const GOOGLE_BUSINESS_REVIEWS = {
  rating: Number.isFinite(googleBusinessRating) ? googleBusinessRating : 4.7,
  reviewCountLabel:
    import.meta.env.VITE_GOOGLE_BUSINESS_REVIEW_COUNT_LABEL || "100+",
  reviewsUrl:
    import.meta.env.VITE_GOOGLE_BUSINESS_REVIEWS_URL ||
    "https://maps.app.goo.gl/1qyDHDy16owBKEncA",
} as const;
export const DEFAULT_OG_IMAGE_EN =
  "https://res.cloudinary.com/dfgcsrgjd/image/upload/v1752853749/IMG-20250718-WA0011_vpeo05.jpg";
// "https://res.cloudinary.com/dkkgs7gan/image/upload/v1730177267/og-image-en_gip6re.png";
export const DEFAULT_OG_IMAGE_FR =
  "https://res.cloudinary.com/dfgcsrgjd/image/upload/v1752853749/IMG-20250718-WA0011_vpeo05.jpg";
// "https://res.cloudinary.com/dkkgs7gan/image/upload/v1730168967/og-image-fr_y89htf.png";

export const Z_INDEX = {
  LEVEL_1: 1, // default
  LEVEL_2: 9,
  LEVEL_3: 99,
  LEVEL_4: 999,
  LEVEL_5: 9999, // Standard modals and tooltips
  LEVEL_6: 99999, // Notifications and very important modals
  LEVEL_7: 999999, // Only to be used for overriding library-level z-indices!
} as const;

export const SESSION_STORAGE_KEYS = {
  // Video call
  VC_THRESHOLD: "t_1",
  VC_DOCTOR_JOINED: "d_j",
  VC_PATIENT_JOINED: "p_j",
  VC_CALL_DURATION_WITH_PATIENT: "c_d",
} as const;

export const VIDEO_CALL_THRESHOLD = {
  doctorJoined: false,
  patientJoined: false,
  callDuration: 0,
};

export const DEFAULT_PAGINATION: Pagination = {
  page: 1, //* This has to be 1 (and not 0) to trigger refetching in useEffect conditions
  pageSize: import.meta.env.DEV ? 25 : 25,
  pageCount: 1,
  total: 0, //* This has to be 0 to avoid the inaccuracy of: "Displaying 0 out of 1 rows"
};

export const IMAGE_FILE_TYPES = [".png", ".jpg", ".jpeg", ".webp"];

export const DOCUMENT_FILE_TYPES = [".pdf", ".doc", ".docx"];

export const MEGABYTE = 1024 * 1024;

export const MAX_FILENAME_LENGTH_BEFORE_UPLOAD = 28; // file name will contain file size, so this has to be a bit shorter

export const COLLECTION_PRICE = 10_000;
